/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BulkSetItemDoneRequest
 */
export interface BulkSetItemDoneRequest {
  /**
   *
   * @type {string}
   * @memberof BulkSetItemDoneRequest
   */
  companyListId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BulkSetItemDoneRequest
   */
  companyListItemIds: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof BulkSetItemDoneRequest
   */
  done: boolean;
}

/**
 * Check if a given object implements the BulkSetItemDoneRequest interface.
 */
export function instanceOfBulkSetItemDoneRequest(
  value: object,
): value is BulkSetItemDoneRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (
    !("companyListItemIds" in value) ||
    value["companyListItemIds"] === undefined
  )
    return false;
  if (!("done" in value) || value["done"] === undefined) return false;
  return true;
}

export function BulkSetItemDoneRequestFromJSON(
  json: any,
): BulkSetItemDoneRequest {
  return BulkSetItemDoneRequestFromJSONTyped(json, false);
}

export function BulkSetItemDoneRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BulkSetItemDoneRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    companyListItemIds: json["companyListItemIds"],
    done: json["done"],
  };
}

export function BulkSetItemDoneRequestToJSON(
  json: any,
): BulkSetItemDoneRequest {
  return BulkSetItemDoneRequestToJSONTyped(json, false);
}

export function BulkSetItemDoneRequestToJSONTyped(
  value?: BulkSetItemDoneRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    companyListItemIds: value["companyListItemIds"],
    done: value["done"],
  };
}
